{
  "dashboard": "Trader Dashboard",
  "portfolio": "Portfolio",
  "transactions": "Transactions",
  "dashboard_page": {
    "title": "Credit Holder Dashboard",
    "subtitle": "Manage your carbon credit portfolio and track market opportunities",
    "stats": {
      "total_credits_owned": "Total Credits Owned",
      "credits_retired": "Credits Retired",
      "portfolio_value": "Portfolio Value",
      "active_transactions": "Active Transactions",
      "this_month": "this month",
      "pending": "pending"
    },
    "recent_transactions": {
      "title": "Recent Transactions",
      "view_all": "View All",
      "purchased_credits": "Purchased Credits",
      "retired_credits": "Retired Credits",
      "transferred_credits": "Transferred Credits",
      "project": "Project",
      "to": "To",
      "retired": "Retired"
    },
    "quick_actions": {
      "title": "Quick Actions",
      "buy_credits": "Buy Credits",
      "transfer_credits": "Transfer Credits",
      "retire_credits": "Retire Credits",
      "export_ledger": "Export Ledger",
      "market_alert": "Market Alert",
      "market_alert_message": "High demand for forestry credits. Consider selling at current market rates."
    },
    "portfolio_breakdown": {
      "title": "Portfolio Breakdown",
      "renewable_energy": "Renewable Energy",
      "forestry_land_use": "Forestry & Land Use",
      "energy_efficiency": "Energy Efficiency",
      "other": "Other",
      "credits": "credits"
    },
    "market_insights": {
      "title": "Market Insights",
      "average_credit_price": "Average Credit Price",
      "trading_volume": "Trading Volume",
      "new_projects": "New Projects",
      "from_last_week": "from last week",
      "credits_traded_this_week": "Credits traded this week",
      "registered_this_month": "Registered this month"
    }
  },
  "register_page": {
    "breadcrumb": {
      "home": "Home",
      "registration": "Registration",
      "credit_holder_trader": "Credit Holder / Trader"
    },
    "header": {
      "title": "Credit Holder / Trader Registration",
      "subtitle": "Register to buy, trade, and retire carbon credits on the SOR Registry"
    },
    "personal_info": {
      "title": "Personal Information",
      "full_name_org": "Full Name / Organization Name",
      "full_name_placeholder": "Enter your full name or organization name",
      "country": "Country",
      "select_country": "Select your country",
      "email_address": "Email Address",
      "email_placeholder": "your.email{'@'}example.com",
      "phone_number": "Phone Number",
      "phone_placeholder": "+1 (555) 123-4567"
    },
    "intended_use": {
      "title": "Intended Use",
      "buy_credits": {
        "title": "Buy Credits",
        "description": "Purchase carbon credits for compliance or voluntary offsetting"
      },
      "trade_credits": {
        "title": "Trade Credits",
        "description": "Engage in carbon credit trading and market activities"
      },
      "retire_credits": {
        "title": "Retire Credits",
        "description": "Permanently retire credits for environmental claims"
      }
    },
    "account_security": {
      "title": "Account Security",
      "password": "Password",
      "password_placeholder": "Create a strong password",
      "password_requirements": "Must be at least 8 characters with uppercase, lowercase, and numbers",
      "confirm_password": "Confirm Password",
      "confirm_password_placeholder": "Confirm your password"
    },
    "terms_declarations": {
      "title": "Terms & Declarations",
      "agree_terms": "I agree to the",
      "terms_conditions": "Terms and Conditions",
      "acknowledge_privacy": "I acknowledge the",
      "privacy_policy": "Privacy Policy",
      "comply_rules": "I agree to comply with SOR Registry rules and regulations",
      "marketing_consent": "I consent to receive updates and marketing communications"
    },
    "form_actions": {
      "create_account": "Create Account (Free)",
      "cancel": "Cancel"
    },
    "registration_info": {
      "title": "Registration Information",
      "free_registration": "Registration is free for Credit Holders and Traders",
      "unique_rin": "You will receive a unique Registry Identification Number (RIN) upon approval",
      "email_verification": "Email verification is required to activate your account",
      "approval_time": "Account approval typically takes 1-2 business days",
      "start_trading": "You can start trading immediately after account activation"
    }
  },
  "sidebar": {
    "dashboard": "Dashboard",
    "credit_ledger": "Credit Ledger",
    "transfer_credits": "Transfer Credits",
    "retire_credits": "Retire Credits",
    "market_explorer": "Market Explorer",
    "portfolio_analytics": "Portfolio Analytics"
  }
}